<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oYLBBp/tc-custom/9781429928502.jpg?1720464496331" alt="This image is the cover for the book Blonde"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blonde
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Boy meets girl. Girl kidnaps boy. Boy loses girl, and is pursued by a professional killer carrying a decapitated head in a gym bag. <i>The Blonde </i>is a modern (crime) love story from<i> The Wheelman</i> author Duane Swierczynski. <br/></b><br/>The night before a big meeting, Jack Eisley is sitting in an airport bar in Philadelphia, chatting up a pretty young blonde. Sure, Jack has a wife and daughter at home, but this is just a little harmless flirting. Harmless, that is, until the blonde leans forward and says, "I poisoned your drink."<br/><br/>She tells Jack that unless she can keep someone within ten feet of her at all times, she'll die. And if he wants the antidote, he'll have to take her back to his hotel room and promise to stay by her side.<br/><br/>Jack thinks: psycho. But as the violent night wears on, and he encounters a relentless government assassin, a threatening voice on a cell phone, a deadly waitress, dirty cops, and shady cab drivers . . . <br/><br/>He begins to believe her...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Duane Swierczynski
      </h2>
      
      <p class="authorDescription body article">DUANE SWIERCZYNSKI is the author of <I>The Wheelman</I>,<I> The Blonde</I>, <I>Severance Package</I>, and <I>Expiration Date</I>, and writes for Marvel Comics.<I> The Wheelman</I> was nominated for the Gumshoe Award. He lives in Philadelphia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Minotaur
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ad974332